export default function AdminInvites(){return <div className='p-8'>Admin Invites</div>}